import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetBanners } from '../../../hooks/banners';

import MainLayout from '../../layouts/Main';
import { SVGIcon } from '../../wrappers/SVGIcon';
import { BannersListTable } from '../../sub_components/tables/BannersList';

import { Icons } from '../../../data/Assets';

const BannersListPage = () => {
    const navigate = useNavigate();

    const { data: banners, isLoading } = useGetBanners();

    const onGoToCreateBanner = () => {
        navigate('/banners/create');
    };

    return (
        <MainLayout>
            <div className="immersion__page_view">
                <h2 className="immersion__color__dark mb_20">Banners</h2>

                <div className="immersion__lists__top_section mb_30">
                    <div className="display_flex display_flex_end mr_10">
                        <button className="immersion__btn immersion__btn__primary" onClick={onGoToCreateBanner}>
                            <SVGIcon src={Icons.Plus} />
                            <span>Add&nbsp;Banner</span>
                        </button>
                    </div>
                </div>

                <div className="immersion__split_list_view">
                    <BannersListTable
                        banners={banners ?? []}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </MainLayout>
    );
};

export default BannersListPage;